import { useSelector } from "react-redux";
import { map } from "lodash";

import classes from "./filter.module.scss";

const FilterEstate = ({ filterEstate, changeEstateFilter }) => {
	const { user } = useSelector((state) => state.auth);
	const { customer } = user;

	return (
		<div className={classes.filterSection}>
			{user && user.estates && (
				<div>
					<h4>
						{customer.customer_screens.find((cs) => cs.screen_id === 51)
							? customer.customer_screens.find((cs) => cs.screen_id === 51).name
							: "Campo"}
					</h4>

					<div className={classes.checkboxRow}>
						<input
							type="checkbox"
							checked={filterEstate.join(",") === map(user.estates, "value").toString()}
							onChange={() => changeEstateFilter("ALL")}
						/>
						<span className={classes.label}>Todos</span>
					</div>

					{user &&
						user.estates.map((estate, i) => {
							return (
								<div key={i} className={classes.checkboxRow}>
									<input
										type="checkbox"
										checked={filterEstate && filterEstate.includes(Number(estate.value))}
										onChange={() => changeEstateFilter(estate.value)}
									/>
									<span className={classes.label}>{estate.label}</span>
								</div>
							);
						})}
				</div>
			)}
		</div>
	);
};

export default FilterEstate;
